import { useEffect, useState } from 'react';
import CasesTable from './CasesTable';
import { useNavigate } from 'react-router-dom';
import { Case } from '../../types';
import { fetchCases } from '../../api/cases';
import { Button } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';

function ListCases() {
  const [cases, setCases] = useState<Case[]>([]);
  const [viewAllOrgs, setViewAllOrgs] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const auth = useAuth();

  const loadCases = async () => {
    if (!auth.user?.id_token) {
      setError('No auth token available');
      setLoading(false);
      return;
    }

    try {
      const response = await fetchCases(auth.user.id_token, { all: viewAllOrgs });
      if (response.status !== 200) {
        throw new Error(`Failed to fetch cases: ${response.statusText}`);
      }
      // Support both API shapes: { cases: [...] } or direct array
      const data: Case[] = response.data.cases || response.data;
      setCases(data);
    } catch (err: any) {
      console.error('Fetch error:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Only load cases when we have an auth token
    if (auth.user?.id_token) {
      loadCases();
    }
  }, [auth.user?.id_token, viewAllOrgs]); // Re-run when token or view mode changes
  
  const isOwner = auth.user?.profile?.email === 'mastalcup@hotmail.com';
  
  const goToCreatePage = () => {
    navigate('/create-case');
  };

  if (loading) {
    return <div className="text-center mt-4">Loading cases...</div>;
  }

  if (error) {
    return <div className="text-center mt-4 text-danger">Error: {error}</div>;
  }

  return (
    <div>
      <h1>Cases</h1>
      <p>This is all of the cases you are allowed to see.</p>
      {isOwner && (
        <div className="mb-3">
          <label className="me-2">View:</label>
          <Button
            variant={viewAllOrgs ? 'primary' : 'outline-primary'}
            onClick={() => setViewAllOrgs(true)}
            className="me-2"
          >
            All Orgs
          </Button>
          <Button
            variant={!viewAllOrgs ? 'primary' : 'outline-primary'}
            onClick={() => setViewAllOrgs(false)}
          >
            My Org
          </Button>
        </div>
      )}
      <Button onClick={goToCreatePage} className='mb-4'>
        Create Case
      </Button>
      {/* <Link to="/view-case/1">View a Sample Case</Link> */}
      <CasesTable cases={cases} />
    </div>
  );
}

export default ListCases;